// extracted by mini-css-extract-plugin
export default {"errorDialog":"CopyButton_errorDialog__Dg2Xp","dialogBody":"CopyButton_dialogBody__lDFd3"};